import { b as __awaiter, c as __generator } from '../tslib.es6-c6da0ae6.js';
import { RECAPTCHA_SITE_KEY } from '../configs/constants/index.js';

var getReCaptchaToken = function getReCaptchaToken(action) {
  return __awaiter(void 0, void 0, void 0, function () {
    var recaptchaToken, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 2,, 3]);
          return [4, new Promise(function (resolve) {
            window.grecaptcha.enterprise.ready(function () {
              return __awaiter(void 0, void 0, void 0, function () {
                var token;
                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      _b.trys.push([0, 2,, 3]);
                      return [4, window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, {
                        action: action,
                        fast: true
                      })];
                    case 1:
                      token = _b.sent();
                      return [2, resolve(token)];
                    case 2:
                      _b.sent();
                      return [2, resolve('')];
                    case 3:
                      return [2];
                  }
                });
              });
            });
          })];
        case 1:
          recaptchaToken = _a.sent();
          return [2, {
            status: 'success',
            token: recaptchaToken
          }];
        case 2:
          err_1 = _a.sent();
          console.error(err_1);
          return [2, {
            status: 'error',
            token: ''
          }];
        case 3:
          return [2];
      }
    });
  });
};

export { getReCaptchaToken as default };
//# sourceMappingURL=index.js.map
